import type { Habilitation, Profil } from '@/models/interfaces/auth/Profil'
import { apiClient } from '@/plugins/axios/api'

/** Profils utilisateur et habilitations qu'ils accordent (securite.profil / securite.habprofil). */
export class ProfilService {
  static async getProfils(): Promise<Profil[]> {
    const data = (await apiClient.get('/api/profils')).data
    return data['hydra:member'] ?? []
  }

  static async getHabilitations(): Promise<Habilitation[]> {
    const data = (await apiClient.get('/api/habilitations')).data
    return data['hydra:member'] ?? []
  }

  /** Remplace l'ensemble des habilitations du profil ; renvoie le profil à jour. */
  static async setHabilitations(profilId: number, habilitations: string[]): Promise<Profil> {
    return (
      await apiClient.put(
        `/api/profils/${profilId}/habilitations`,
        { habilitations },
        { headers: { 'Content-Type': 'application/json' } },
      )
    ).data
  }
}
